import { MultiplicityPatterns } from './MultiplicityPatterns';
const result = {};
for (const { value, multiplicity, names } of MultiplicityPatterns) {
    if (multiplicity)
        result[value] = multiplicity - 1;
    for (const name of names) {
        if (multiplicity)
            result[name] = multiplicity - 1;
    }
}
export const couplingValues = result;
//# sourceMappingURL=couplingValues.js.map